import Book from './book'

interface CourseInterface {
    id: number;
    name: string;
    acronym: string;
    books: Book[];
}

export default class Course implements CourseInterface {
    id = -1
    name = ''
    acronym = ''
    grade = ''
    books = []
}
